module.exports = __webpack_public_path__ + "assets/img/crown.80ae3746.svg";